import { useAuth0 } from '@auth0/auth0-react'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import { createSession } from '../../redux/storeConfig/slices/slice.auth'

export default function Auth0Callback() {
  /** @type {import('../../redux/storeConfig/slices/slice.auth/auth.types').AuthSlice} */
  const auth = useSelector(state => state.auth)
  const dispatch = useDispatch()

  const { getIdTokenClaims, user, isAuthenticated } = useAuth0()

  const history = useHistory()

  useEffect(() => {
    const fetchAuth0Token = async () => {
      if (isAuthenticated && user) {
        const idTokenClaims = await getIdTokenClaims()
        const idToken = idTokenClaims.__raw

        const userData = {
          auth0Token: {
            token: idToken,
            email: user.email,
            name: user.name,
            uid: user.sub
          }
        }
        const session = await dispatch(createSession(userData))

        if (typeof session !== 'string') history.push('/login')
      }
    }

    fetchAuth0Token()
  }, [isAuthenticated, user, getIdTokenClaims, dispatch, history])

  return <></>
}

// export default connect(null, { createSession })(Auth0Callback)
